var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8811_3306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.52424 3.45009H1.87422V2.4H3.52424V3.45009ZM5.77422 2.4V3.45009H4.12424V2.4H5.77422ZM8.0242 2.4V3.45009H6.37422V2.4H8.0242ZM10.2742 2.4V3.45009H8.6242V2.4H10.2742ZM10.2742 5.09982H8.6242V4.05009H10.2742V5.09982ZM10.2742 6.37514L8.6242 6.52505V5.70018H10.2742V6.37514ZM3.52424 5.70018V6.97514L1.87422 7.12505V5.70018H3.52424ZM3.52424 5.09982H1.87422V4.05009H3.52424V5.09982ZM5.77422 5.09982H4.12424V4.05009H5.77422V5.09982ZM6.37422 5.09982V4.05009H8.0242V5.09982H6.37422ZM5.77422 6.77982L4.12424 6.93009V5.70018H5.77422V6.77982ZM6.37422 5.70018H8.0242V6.57009L6.37422 6.72V5.70018ZM11.1742 7.2V1.49982H1.87422V1.34991C1.87422 0.600002 1.27422 0 0.524237 0C0.269209 0 0.0742188 0.194952 0.0742188 0.45009C0.0742188 0.704859 0.269209 0.90018 0.524237 0.90018C0.779228 0.90018 0.974219 1.09514 0.974219 1.34991V8.85009C0.974219 9.6 1.57422 10.2 2.32424 10.2H2.77422H9.37422H10.7242C10.9792 10.2 11.1742 10.005 11.1742 9.74991C11.1742 9.49514 10.9792 9.30018 10.7242 9.30018H2.32424C2.06921 9.30018 1.87422 9.10486 1.87422 8.85009V8.02487L11.1742 7.2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.675 11.1C3.675 11.5974 3.27206 12.0002 2.775 12.0002C2.27794 12.0002 1.875 11.5974 1.875 11.1C1.875 10.603 2.27794 10.2002 2.775 10.2002C3.27206 10.2002 3.675 10.603 3.675 11.1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2746 11.1C10.2746 11.5974 9.87167 12.0002 9.37461 12.0002C8.87755 12.0002 8.47461 11.5974 8.47461 11.1C8.47461 10.603 8.87755 10.2002 9.37461 10.2002C9.87167 10.2002 10.2746 10.603 10.2746 11.1Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8811_3306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.065cb0012921b0ceb0b136671f7cbae9.svg";
export { ForwardRef as ReactComponent };